import { LoadablePaint } from '@confluence/loadable';

export const Nav3Layout = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav3-layout" */ './nav3/PageLayout.tsx')).PageLayout,
});
